<template>
  <div class="pwc-profile">
    <div class="pwc-profile-main">
      <div class="pwc-profile-avatar">
        <pwc-avatar :avatar="avatar" :upload="uploadAvatar" />
      </div>
      <div class="pwc-profile-info">
        <info-item v-for="i in infoList" :key="i.title" :info="i" />
      </div>
      <div class="">
        <v-layout row>
          <v-flex xs12>
            <v-card tile>
              <div style="height: 120px; display:flex;justify-content:center;lign-items:center; padding-top:40px;">
                <v-chip
                  v-for=" r in resumeEntities"
                  :key="r.fName"
                  v-model="r.isShow"
                  hover
                  class="pwc-resume"
                  close
                  color="orange"
                  label
                  outline
                  @input="removFile(r.fName)"
                  @click="downLoad(r.fUrl)"
                ><span>{{ r.fName }}</span></v-chip>
                <v-btn
                  v-if="!resumes"
                  color="blue-grey"
                  class="white--text"
                  @click="uploadInputClick"
                >
                  上传简历
                  <v-icon right dark>fas fa-cloud-upload-alt</v-icon>
                </v-btn>
              </div>
              <input id="upload" ref="uploadInput" type="file" accept=".doc, .docx, .pdf" @change="changeimg">
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="pwc-profile-action">
      <v-btn block outline color="#D04A02" @click="update">更新资料</v-btn>
      <v-btn block outline color="#D04A02" @click="logout">退出登录 </v-btn>
    </div>

  </div>
</template>

<script>
import PwcAvatar from '../../../PwcAvatar'
import InfoItem from '../InfoItem'

import { mapActions } from 'vuex'
import { upload } from '@/mixin/file'
import { loading } from '@/mixin'
import Actions from '@/constants/action'

export default {
  components: {
    PwcAvatar,
    InfoItem
  },
  mixins: [upload, loading],
  props: {
    infoList: {
      type: Array,
      default: () => []
    },
    avatar: {
      type: String,
      default: ''
    },
    uploadAvatar: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    },
    logout: {
      type: Function,
      default: () => {}
    },
    resumes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      resumeEntities: []
      // hasFile: false,
      // fileName: '',
      // fileUrl: '',
      // fixedFileName: '',
      // uploading: false
    }
  },
  mounted() {
    this.resumeEntities = this.resumes.map(r => { return { fName: decodeURI(r.item1), fUrl: r.item2, isShow: true } })
  },
  methods: {
    ...mapActions({
      updateResume: Actions.UPDATE_RESUME
    }),
    uploadInputClick() {
      const uploadbtn = this.$refs.uploadInput
      uploadbtn.click()
    },
    async changeimg(e) {
      const accept = '.pdf,.doc,.docx'
      const name = e.target.files[0].name
      const flieArr = name.split('.')
      const suffix = flieArr[flieArr.length - 1] || ''

      if (!accept.includes(suffix.toLowerCase())) {
        this.$dialog.alert({
          message: '只有pdf，doc，docx格式文档允许被上传',
          confirmButtonText: 'OK'
        })
        return false
      }
      this.uploading = true
      await this.uploadFile(e, '', false)
        .then(key => {
          return this.updateResume({
            item: key,
            isDelete: 0
          })
        })

      this.uploading = false

      this.resumeEntities = this.resumes.map(r => { return { fName: decodeURI(r.item1), fUrl: r.item2, isShow: true } })
    },
    removFile(fixedFileName) {
      this.updateResume({
        item: encodeURI(fixedFileName),
        isDelete: 1
      })
      // this.hasFile = false
      // this.fixedFileName = ''
      // this.fileUrl = ''
      // this.fileName = ''
    },
    downLoad(fileUrl) {
      if (fileUrl) {
        console.log(fileUrl)
        window.open(fileUrl)
      } else {
        this.handleDialogMessage('文件丢失，请重新上传')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#upload{
    height: 0;
    width: 0;
    visibility: hidden;
}
.pwc-resume {
  width:auto;
  max-width:90%;
  span{
    cursor: pointer;
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap !important;
  }
}
.pwc-profile {
    margin: auto;
    .pwc-profile-main {
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08);
        .pwc-profile-avatar {
            background-color: #FFB600;
            display: flex;
            justify-content: center;
            padding: 36px;
        }
        .pwc-profile-info {
            padding: 24px;
        }
    }
    .pwc-profile-action {
        margin-top: 12px;
    }
}
</style>
